import AnnotatedProgressBar from './AnnotatedProgressBar';

export default AnnotatedProgressBar;
